<template>
    <div class="layout__header">
        <!--      <div v-responsive.lg.xl>DESKTOP</div>-->
        <!--      <div v-responsive.xs.sm.md>MOBILE</div>-->
        <tasty-burger-button
                id="test-button-hamburger-menu"
                ref="tastyBurger"
                type="slider"
                :active="hamburgerOpen"
                size="s"
                color="#B2DE4D"
                active-color="#b2b2b2"
                @toggle="toggleBurger"
                v-responsive.xs.sm.md/>
        <div class="burger-menu" v-bind:class="{'burger-menu-open':!hamburgerOpen}"
             v-responsive.xs.sm.md>
            <div class="burger-item" v-on:click="itemClicked">
                <div class="layout__header__menu__user">
                    <BaseAvatar/>
                    <span>{{user.username}}<!--<br/>{{user.email}}--></span>
                </div>
                <div class="layout__header__menu__log-out" v-on:click="itemClicked">
                    <div v-on:click="logOut" class="mobile-logout test-mobile-button-logout">
                        <span style="margin-right:1em;">Logout</span>
                        <BaseIcon v-tooltip.bottom="$t('login.logout')" class="logout-icon"
                                  icon="logout"/>
                    </div>
                </div>
            </div>
            <router-link
                    id="test-hamburger-link-dashboard"
                    :to="{ name: 'dashboard', params: {lang: $i18n.locale.toLowerCase(), type: type.label} }"
                    class="burger-item" v-on:click.native="itemClicked">
                <BaseIcon icon="dashboard"></BaseIcon>
                Dashboard
            </router-link>
            <div class="burger-item burger-item--level"
                 :id="`test-hamburger-link-${item.urlSlug}`"
                 v-for="(item,index) in tentacles"
                 v-bind:key="index"
                 v-bind:class="{'burger-item--active': item.label === type.label}"
                 @click="setTentacleType(item)"
                 v-responsive.xs>
                &#x25cf;<span>{{item.name}}</span>
                <!--            style="margin-left: 0.5em;font-size:0.9em;"-->
            </div>
            <router-link :to="{ name: 'server-status' }" class="burger-item"
                         id="test-hamburger-link-server-status"
                         v-on:click.native="itemClicked">
                <BaseIcon icon="server"></BaseIcon>
                Server status
            </router-link>
        </div>
        <img src="/Tentacles_logo.png" alt="Tentacles Logo" v-responsive.xs.sm.md/>
        <div class="layout__header__menu">
            <div
                    class="layout__header__menu__customer test-button-customer"
                    v-click-outside="hideCustomerSelectList"
                    @click="toggleCustomerSelectList"
                    v-if="showCustomerSelect"
            >
                <span class="layout__header__menu__customer__name" v-tooltip.bottom="$t('tooltips.customer')">
                    {{ customer.name }}
                <BaseIcon v-if="isMultipleCustomers" icon="chevron-down"  />
                </span>
                <transition name="fadeUp" v-if="isMultipleCustomers">
                    <BaseSelectList
                            v-if="showCustomerSelectList"
                            :items="customers"
                            :active="customer"
                            @onSelect="setCustomer"
                            class="select-list-mobile"
                    />
                </transition>
            </div>
            <div class="timeformat" v-on:click="changeTimeFormat">
                <span v-bind:class="{'timeformat-item--active': timeFormat}">12h</span>
                /
                <span v-bind:class="{'timeformat-item--active': !timeFormat}">24h</span>
            </div>
            <div class="nameformat" v-on:click="changeNameFormat">
                <span v-bind:class="{'nameformat-item--active': nameFormat}">{{ $t('header.custom_name') }}</span>
                /
                <span v-bind:class="{'nameformat-item--active': !nameFormat}">{{ $t('header.generic_name') }}</span>
            </div>
            <div
                    class="layout__header__menu__lang test-button-language"
                    v-click-outside="hideLangSelectList"
                    @click="toggleLangSelectList"
            >
                {{ lang.name }}
                <BaseIcon icon="chevron-down"/>
                <transition name="fadeUp">
                    <BaseSelectList
                            v-if="showLangSelectList"
                            :items="languages"
                            :active="lang"
                            @onSelect="setLang"
                            class="select-list-mobile"
                    />
                </transition>
            </div>
            <div class="layout__header__menu__user" v-responsive.lg.xl>
                <BaseAvatar/>
                <span>{{user.username}}<!--<br/>{{user.email}}--></span>
                <div class="layout__header__menu__user__badge" v-if="user.is_dealer"> dealer </div>
            </div>
            <div class="layout__header__menu__log-out" v-responsive.lg.xl>
                <BaseIcon v-on:click="logOut" v-tooltip.bottom="$t('login.logout')" icon="logout"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { TastyBurgerButton } from 'vue-tasty-burgers';
import languages from '@/config/languages';
import 'vue-tasty-burgers/dist/vue-tasty-burgers.css';
import store from '../../store';

export default {
  name: 'LayoutHeader',
  components: {
    'tasty-burger-button': TastyBurgerButton,
  },
  data() {
    return {
      showCustomerSelectList: false,
      showLangSelectList: false,
      showUserMenu: false,
      hamburgerOpen: false,
      dealer: {
        id: 'dealer-view',
        name: this.$t('dashboard.dealer_view'),
      },
    };
  },
  computed: {
		...mapGetters('tentacle', ['user', 'type', 'is_dealer', 'tentacles', 'timeFormat', 'nameFormat']),
		...mapGetters('customer', ['customers', 'customer']),
		languages() {
			return languages;
		},
    isMultipleCustomers() {
      return this.customers.length > 1 || this.user.is_dealer;
    },
    lang() {
        if (typeof this.user.lang === 'undefined') {
            this.$store.dispatch('customer/setLogout');
            return {'id': 1, 'name': 'EN'};
        }
        this.moment.locale(this.user.lang.name.toLowerCase());
        return this.user.lang;
    },
    showCustomerSelect() {
      return (this.$route.path === '/' || this.$route.path.indexOf('dashboard') > -1);
    },
  },
  methods: {
    log(msg) {
      console.log(msg);
    },
    changeTimeFormat() {
      const toggleValue = !this.$store.getters['tentacle/timeFormat'];
      this.$store.dispatch('tentacle/setTimeFormat', toggleValue);
    },
    changeNameFormat() {
      const toggleValue = !this.$store.getters['tentacle/nameFormat'];
      this.$store.dispatch('tentacle/setNameFormat', toggleValue);
    },
    setTentacleType(tentacleType) {
      this.itemClicked();
      this.$router.push({
        name: 'dashboard',
        params: { lang: this.$i18n.locale.toLowerCase(), type: tentacleType.label },
      });
    },
    itemClicked() {
      this.$refs.tastyBurger.$el.click();
      this.toggleBurger(false);
    },
    toggleBurger(val) {
      this.hamburgerOpen = val;
    },
    hideCustomerSelectList() {
      this.showCustomerSelectList = false;
    },
    hideLangSelectList() {
      this.showLangSelectList = false;
    },
    toggleLangSelectList() {
      this.showLangSelectList = !this.showLangSelectList;
    },
    toggleCustomerSelectList() {
      this.showCustomerSelectList = !this.showCustomerSelectList;
    },
    setLang(lang) {
        const {params} = this.$route;
        params.lang = lang.name.toLowerCase();
        const {query} = this.$route;

        this.$router.push({name: this.$route.name, params, query});
        this.$i18n.locale = lang.name;

        this.$store.dispatch('tentacle/setLang', {'lang': lang.name.toLowerCase()});
    },
    async setCustomer(customer) {
      if (this.user.is_dealer && customer.id === 'dealer-view') {
        this.$store.dispatch('customer/setCustomer', this.dealer);
      } else {
        this.$store.dispatch('customer/setCustomer', customer);
      }

      if (this.user.is_dealer && customer.id === 'dealer-view') {
        await this.$store.dispatch('tentacle/setTentacles', null);
      } else {
        await this.$store.dispatch('tentacle/setTentacles', customer.id);
      }

      let tentacleTypes = this.$store.getters['tentacle/tentacles'];

      if (tentacleTypes.length > 0) {
        let tType = tentacleTypes[0];
        let params = {customer: customer, type: tType};
        this.$store.dispatch('tentacle/setType', params);

        this.$router.push({ name: 'dashboard', params: { lang: this.$i18n.locale.toLowerCase(), type: tType.urlSlug } });
      }
    },
    logOut() {
      this.$store.dispatch('customer/setLogout');
      this.$store.dispatch('tentacle/setLogout');
      this.$router.push({ path: '/login' });
    },
  },
};
</script>

<style lang="scss" scoped>
    @import 'layout-header';
    .timeformat, .nameformat {
      font-size: 1.4em;
      color: #9b9b9b;
      padding:0.25em 2em;
      margin-right: 2em;
      border-right: 0.1rem solid #eee;
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      letter-spacing: 0.25px;
      &:hover {
        margin-top:1px;
        padding:0.5em 2em;
        background: #f8f8f8;
        border-radius: 0.5em;
        border-right: 0.1rem solid transparent;
      }
      &:active {
        background: white;
      }
      span {
        transition: color 0.05s linear;
        width: 1em;
      }
      &-item--active {
        font-weight: bold;
        color:$company-color-light;
      }
    }
    .burger-menu {
        border-top: 1px solid rgba(205, 205, 205, 0.31);
        position: absolute;
        min-height: max-content;
        width: 100vw;
        max-width: 30em;
        background: white;
        top: 7rem;
        left: -100vw;
        transform: translate(100vw, 0);
        transition: all 0.15s ease-in-out;
        box-shadow: 0 3px 3px rgba(100, 116, 160, 0.15);
        text-align: center;
        background: white;

        &-open {
            transform: translate(-100vw, 0);
        }

        .burger-item {
            z-index: 1;
            text-align: left;

            cursor: pointer;

            &:first-child {
                padding-top: 3em;
            }

            color: #9b9b9b;

            &:hover {
                color: #B2DE4D;
            }

            align-items: center;
            display: flex;
            font-size: 1.4em;
            font-weight: 500;
            text-decoration: none;
            margin: auto;
            margin-bottom: 2.5em;
            width: 100%;
            padding: 0 2.5em;

            &--level {
                margin-left: 2.5em;
                transition: all 0.15s ease-in-out;
            }

            &--active {
                color: #B2DE4D;
                margin-left: 3em;
            }

            .layout__header__menu__log-out {
                margin-right: 0;
                margin-left: auto;
                border: none;

                .mobile-logout {
                    display: flex;
                    align-items: center;
                }

                .logout-icon {
                    fill: #ca3535;
                }
            }

            .icon {
                fill: #9b9b9b;
                margin-right: 1em;
                height: unset;
            }

            &:last-child {
                padding-bottom: 5em;
            }

            span {
                margin-left: 0.5em;
                font-size: 0.9em;
            }
        }
    }
</style>
